import React from "react";
import styles from "./index.module.scss";

interface Props {
    children: React.ReactNode[];
}
const Index = ({ children }: Props) => {
    return (
        <div className={styles.root}>
            {children.map((item, index) => (
                <div key={index} className={styles.item}>
                    {item}
                </div>
            ))}
        </div>
    );
};

export default Index;
